// extracted by mini-css-extract-plugin
export default {"mainContent":"EligibleProductsDialog_mainContent__uNOIR","form":"EligibleProductsDialog_form__o115F","noResults":"EligibleProductsDialog_noResults__O79Ox"};